module.exports = __webpack_public_path__ + "img/Rectangle.0fe86f08.svg";